






















































































































































import Component, {mixins} from 'vue-class-component';
import Loader from '@/components/Loader.vue';
import {Getter, State} from 'vuex-class';
import UserGroup from '@/modules/user/model/UserGroup';
import {DateMixin} from '@/modules/core/date';
import ConfirmDeleteUserGroup from '@/modules/user/components/UserGroup/ConfirmDeleteUserGroup.vue';
import {Prop} from 'vue-property-decorator';

/**
 * Lista de grupos de usuarios
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
@Component({
    components: {ConfirmDeleteUserGroup, Loader},
})
export default class UserGroupList extends mixins(DateMixin) {
    /**
     * Grupos de usuarios registrados en la aplicación
     *
     * @var { UserGroup[] }
     */
    @State(state => state.user.userGroups)
    public groups: UserGroup[]

    @Prop({type: Boolean, default: false})
    public selectable: boolean

    /**
     * Si esta opción se encuentra activa, el botón de "Eliminar" no será
     * renderizado en las tarjetas.
     */
    @Prop({type: Boolean, default: false})
    public hideDeleteButton: false

    /**
     * Tamaño de columna para las tarjetas de la grilla
     */
    @Prop({type: Object, default: () => ({})})
    public itemBreakpoints: {
        xs: number,
        sm: number,
        md: number,
        lg: number,
        xl: number,
    }

    /**
     * Lista de grupos personalizada
     *
     * Permite que un componente padre muestre una lista de grupos diferente a la
     * lista almacenada en el estado de la aplicación
     *
     * @var { UserGroupList[] }
     */
    @Prop({type: Array, default: () => null})
    public items: UserGroupList[] | null

    /**
     * Esta propiedad se encuentra activa, la barra superior del componente
     * no será mostrada
     */
    @Prop({type: Boolean, default: false})
    public hideToolbar: boolean

    /**
     * Lista de usuarios seleccionados
     *
     * @var { UserGroup[] }
     */
    @Prop({type: Array, default: () => []})
    public value: UserGroup[]

    /**
     * Oculta el pie de la tabla
     */
    @Prop({type: Boolean, default: false})
    public hideFooter: boolean

    /**
     * Nombre del botón para eliminar un grupo
     */
    @Prop({type: String, default: 'Eliminar'})
    public deleteButtonName: string

    /**
     * Indica si debe de mostrar o no un tipo de grupo en la lista de grupos a visualizar, es decir,
     * si esta variable es valor 0 no realiza validación, muestra todos los grupos, si el valor es 1 no admitir
     * mostrar en el componente UserGroupList los grupos que sean padre, y si es valor 2, es motrar solo los grupos
     * padre, osea no mostrar los grupos hijos.
     */
    @State(state => state.user.validateGroupYesNotBeParent)
    public validateGroupYesNotBeParent: number

    @Getter('moduleIsEnabled')
    public moduleIsEnabled: (module: string) => boolean

    public loading = true
    public reloading = false
    public confirmDelete = false

    /**
     * Termino de búsqueda
     */
    public search = ''
    public searchDialog = false
    public sortBy = 'name'
    public sortDesc = false

    /**
     * Contendrá una etiqueta que indica que filtro se aplicado a mostrar los grupos
     * puediendo ser blaco (se muestra todos los grupos) o "Grupos solo hijos o no sin agrupar", "Solo Grupos padres"
     */
    public groupTagTypeDisplayed = ''
    private justParents = 'Solo Grupos padres'
    private tabChildrenOnlyOrNotGrouped = 'Grupos solo hijos o sin agrupar'
    /**
     * Filtro de grupos para el VDataIterator
     */
    public groupFilter (items: UserGroup[], search: string) {
        const appRouterIsEnabled = this.moduleIsEnabled('app-router')
        if (!search) {
            return items
        }

        return items.filter(group => {
            const nameMatch = group.name.toLowerCase().includes(search.toLowerCase())
            // Si el módulo del enrutador se encuentra activo, filtrará tambien por número
            // de serie.
            const serialNumberMatch = appRouterIsEnabled
                 ? group.attributes.SERIAL_NUMBER && (group.attributes.SERIAL_NUMBER as string).includes(search)
                 : true
            return nameMatch || serialNumberMatch 
        })
    }

    public sortByFields = [
        { value: 'id', text: 'ID' },
        { value: 'name', text: 'Nombre' },
        { value: 'createdAt', text: 'Fecha de creación' },
        { value: 'updatedAt', text: 'Fecha de actualización' },
        { value: 'userCount', text: 'Número de usuarios' },
    ]

    public get toolbarClasses () {
        return {
            'elevation-3': this.$vuetify.theme.dark,
            'border-bottom-grey': !this.$vuetify.theme.dark,
        }
    }

    /**
     * Al crear el componente carga la lista de grupos de usuarios registrados en
     * la aplicación
     */
    public async created () {
        await this.$store.dispatch('user/loadUserGroups')
        const appRouterIsEnabled = this.moduleIsEnabled('app-router')
        
        // Filtro Para mostrar todos los grupos, solo los grupos que son padres o solo los grupos que son hijos.
        // Esto filtra si solo se tiene el módulo enrutador, ya que dependiendo de donde se llame se quiere mostrar un grupo u otro.
        // Normalmente se filtrará cuando se quiere asignar un grupo a otro, esto es cuando se quiere asignar grupos
        // a un grupo padre, pero no se puede mostrar los grupos que son padre, pues un padre no puede ser a su vez hijo de otro grupo.
        if(appRouterIsEnabled && this.items === null){
            this.items = this.filterParentGroupsYesNot()
        }

        this.loading = false
    }

    public deleteUserGroup (group: UserGroup) {
        this.$store.commit('user/SET_CURRENT_USER_GROUP', group)
        this.confirmDelete = true
    }

    public async reload () {
        this.reloading = true
        await this.$store.dispatch('user/loadUserGroups', {force: true})

        this.reloading = false
    }

    /**
     *  Filtro Para mostrar todos los grupos, solo los grupos que son padres o solo los grupos que son hijos.
     *  Esto filtra si solo se tiene el módulo enrutador, ya que dependiendo de donde se llame se quiere mostrar un grupo u otro.
     *  Normalmente se filtrará cuando se quiere asignar un grupo a otro, esto es cuando se quiere asignar grupos
     *  a un grupo padre, pero no se puede mostrar los grupos que son padre, pues un padre no puede ser a su vez hijo de otro grupo.
     *  Si validateGroupYesNotBeParent es cero no filtra, si es 1 no muestra solo los grupos padres, si es 2 muestra solo los que no son padres
     *  
     */
    public filterParentGroupsYesNot(): any  {
        this.groupTagTypeDisplayed = '';
        //Si no tiene que realizar filtro mostrar todos los grupos 
        if(this.validateGroupYesNotBeParent === 0) {
            return  this.groups;
        } 
        // Si se tiene otro valor se ha de realizar el filtro
        const g = new Array<UserGroup>();
        this.groups.forEach( e => {
          // if(this.validateGroupYesNotBeParent  === 1 && (e.children && e.groupChildrenCout > 0)){  
          if(this.validateGroupYesNotBeParent  === 1 && (e.groupChildrenCout > 0)){
              g.push(e);
          } else if(this.validateGroupYesNotBeParent  === 2 && (e.groupChildrenCout == 0)){
              g.push(e);
          }
        }) 
        if(this.validateGroupYesNotBeParent  === 1){
            this.groupTagTypeDisplayed = this.justParents;
        } else if(this.validateGroupYesNotBeParent  === 2){
            this.groupTagTypeDisplayed = this.tabChildrenOnlyOrNotGrouped; 
        }
        return g
    }
        
}
